import { defineComponent as s, createBlock as p, openBlock as l, resolveDynamicComponent as m, mergeProps as d, unref as o } from "vue";
import r from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Divider/divider.js";
import { classesFromBreakpointProps as n } from "../breakpoints.js";
import { useOUIAProps as c } from "../helpers/ouia.js";
const S = /* @__PURE__ */ s({
  name: "PfDivider",
  __name: "Divider",
  props: {
    component: { default: "hr" },
    vertical: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    inset: {},
    insetSm: {},
    insetMd: {},
    insetLg: {},
    insetXl: {},
    inset2xl: {},
    orientation: {},
    orientationSm: {},
    orientationMd: {},
    orientationLg: {},
    orientationXl: {},
    orientation2xl: {}
  },
  setup(t) {
    const i = t, a = c({ id: i.ouiaId, safe: i.ouiaSafe });
    return (e, f) => (l(), p(m(e.component), d(o(a), {
      role: e.component !== "hr" ? "separator" : void 0,
      class: [
        o(r).divider,
        o(n)(e.$props, ["inset"], o(r)),
        o(n)(e.$props, ["orientation"], o(r), { short: !0 }),
        {
          [o(r).modifiers.vertical]: e.vertical
        }
      ]
    }), null, 16, ["role", "class"]));
  }
});
export {
  S as default
};
